import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var INPTracker = /*#__PURE__*/function () {
  function INPTracker(options) {
    _classCallCheck(this, INPTracker);
    /**
     * INP stands for Interaction to Next Paint
     */
    _defineProperty(this, "name", 'inp');
    this.includedInteractions = (options === null || options === void 0 ? void 0 : options.includedInteractions) || ['pointerdown', 'pointerup', 'click', 'keydown', 'keyup'];
    this.monitor = new InteractionTracker(this.includedInteractions);
  }
  return _createClass(INPTracker, [{
    key: "start",
    value: function start(paused) {
      var result = this.monitor.start(paused);
      return result;
    }
  }, {
    key: "end",
    value: function end() {
      var result = this.monitor.end();
      return result;
    }
  }, {
    key: "pause",
    value: function pause() {
      this.monitor.pause();
    }
  }, {
    key: "resume",
    value: function resume() {
      this.monitor.resume();
    }
  }]);
}();
var InteractionResult = /*#__PURE__*/function () {
  function InteractionResult() {
    _classCallCheck(this, InteractionResult);
    this.min = Infinity;
    this.max = 0;
    this.average = 0;
    this.numerator = 0;
    this.count = 0;
  }
  return _createClass(InteractionResult, [{
    key: "update",
    value: function update(duration) {
      if (duration > this.max) {
        this.max = duration;
      }
      if (duration < this.min) {
        this.min = duration;
      }
      this.numerator += duration;
      this.count += 1;
      this.average = this.numerator / this.count;
    }
  }, {
    key: "toMeasure",
    value: function toMeasure() {
      return {
        min: this.count === 0 ? 0 : this.min,
        max: this.max,
        average: this.average,
        numerator: this.numerator,
        denominator: this.count
      };
    }
  }]);
}();
var InteractionTracker = /*#__PURE__*/function () {
  function InteractionTracker(includedInteractions) {
    _classCallCheck(this, InteractionTracker);
    _defineProperty(this, "paused", false);
    this.performanceObserver = null;
    this.interactionResult = new InteractionResult();
    this.includedInteractions = includedInteractions;
  }
  return _createClass(InteractionTracker, [{
    key: "stopTracking",
    value: function stopTracking() {
      var _this$performanceObse;
      (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.disconnect();
      this.performanceObserver = null;
    }
  }, {
    key: "startTracking",
    value: function startTracking() {
      var _this = this;
      this.performanceObserver = new PerformanceObserver(function (list) {
        // Note: find link to actual safari issue .. good to get rid of this if Safari has fixed this
        // Delay by a microtask to workaround a bug in Safari where the
        // callback is invoked immediately, rather than in a separate task.
        // See: https://github.com/GoogleChrome/web-vitals/issues/277
        Promise.resolve().then(function () {
          var entries = list.getEntries();
          entries.forEach(function (entry) {
            // Skip further processing for entries that cannot be INP candidates.
            //
            // When a user interacts with a web page, a user interaction (for example a click) usually triggers a sequence of events.
            // To measure the latency of this series of events, the events share the same interactionId.
            // An interactionId is only computed for the following event types belonging to a user interaction. It is 0 otherwise.
            // * click / tap / drag events: 'pointerdown', 'pointerup', 'click'
            // * keypress events: 'keydown', 'keyup'
            //
            if (!entry.interactionId) {
              return;
            }
            if (_this.includedInteractions.includes(entry.name)) {
              _this.interactionResult.update(entry.duration);
            }
          });
        });
      });

      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      if (PerformanceObserver.supportedEntryTypes.includes('event')) {
        this.performanceObserver.observe({
          type: 'event',
          buffered: true,
          durationThreshold: 40
        });
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.stopTracking();
      this.interactionResult = new InteractionResult();
    }
  }, {
    key: "start",
    value: function start(paused) {
      var lastResult = this.interactionResult.toMeasure();
      this.reset();
      this.paused = paused;
      if (!paused) {
        this.startTracking();
      }
      return lastResult;
    }
  }, {
    key: "end",
    value: function end() {
      try {
        return this.interactionResult.toMeasure();
      } finally {
        this.reset();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (this.paused) {
        return;
      }
      this.paused = true;
      this.stopTracking();
    }
  }, {
    key: "resume",
    value: function resume() {
      if (!this.paused) {
        return;
      }
      this.paused = false;
      this.startTracking();
    }
  }]);
}();